/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BlockPOST = {
    readonly id?: number;
    specimen_id: number;
    name: string | null;
    lis_state?: string | null;
    piece_count?: BlockPOST.piece_count | null;
    readonly created_at?: string;
    readonly updated_at?: string;
    lab_station_id?: number | null;
}

export namespace BlockPOST {

    export enum piece_count {
        _0 = '0',
        _1 = '1',
        _2 = '2',
        _3 = '3',
        _4 = '4',
        _5 = '5',
        _1F = '1F',
        _2F = '2F',
        _3F = '3F',
        _4F = '4F',
        _5F = '5F',
        F = 'F',
    }


}
